import { jarallax, jarallaxVideo } from "jarallax";
import bg from '../../images/t3-bg.jpg';

export default function() {
  const widgetName = 'cardWidgetImageCards';
  const widgetOpts = cardWidgetImageCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      // $('<h2 class="t3-heading">Find your place <span>AT THE CENTER.</span></h2>').insertBefore(`#${widgetName}`);
      $('<h2 class="t3-heading">Discover the <span>POSSIBILITIES.</span></h2>').insertBefore(`#${widgetName}`);
      $(`#${widgetName} .buttonwrap a`).addClass('button');
      $(`#${widgetName} .card-widget-item`).each(function() {
        $(this).find('.card-widget-title').appendTo($(this));
      });

      // load parallax background
      $('.section-tier-three').css('background-image', `url('${bg}')`);
      $('.section-tier-three').addClass('jarallax');
      
      $(window).load(function() {
        jarallax(document.querySelectorAll('.jarallax'), {
          speed: 0.2,
          disableParallax: /iPad|iPhone|iPod|Android/,
        });
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 30,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: true
  });

}